import { render, staticRenderFns } from "./RegisterCompanyName.vue?vue&type=template&id=0009a9fe&"
import script from "./RegisterCompanyName.vue?vue&type=script&lang=js&"
export * from "./RegisterCompanyName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports